/**
 * The IDL of the module.
 *
 * @module
 */
/** The IDL of the module. */
export const idl = {
  module_id: "0x1::util",
  doc: "Utility functions used by the framework modules.",
  functions: [],
  structs: [],
  errors: {},
} as const;
